// Versão do app - gerado automaticamente
export const APP_VERSION = '5.51'
export const BUILD_DATE = '15/08/2026, 01:07'
